export default "  // empty\n";
//# sourceMappingURL=lighting-common.glsl.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/luma.gl/dist/esm/shadertools/modules/lighting/lighting-common.glsl.js
// module id = 352
// module chunks = 0